import { useEffect } from 'react';
import { AuthApi, IS_ESOFT_USER_KEY } from 'api';
import { useAuth } from 'modules/auth/hooks';
import appRoutes from 'app.routes';

export const useAuthRedirect = () => {
  const currentPath = window.location.pathname;
  const isAuthenticated = AuthApi.isAuthenticated();
  const { user, userIsLoading } = useAuth();
  const isEsoftUser = localStorage.getItem(IS_ESOFT_USER_KEY) === 'true';

  const isAuthPage = [appRoutes.v2.login, appRoutes.v2.authRedirect, appRoutes.v2.activeDirectory].includes(
    currentPath
  );

  useEffect(() => {
    // Skip if on auth pages
    if (isAuthPage || isAuthenticated) return;

    if (!isAuthenticated) {
      window.location.href = isEsoftUser ? appRoutes.v2.activeDirectory : appRoutes.v2.login;
      return;
    }

    // If authenticated but no user data after loading completes, redirect
    if (isAuthenticated && !userIsLoading && !user) {
      window.location.href = isEsoftUser ? appRoutes.v2.activeDirectory : appRoutes.v2.login;
    }
  }, [isAuthenticated, user, userIsLoading, isAuthPage, isEsoftUser]);

  return {
    isAuthenticated,
    userIsLoading,
    user,
    isAuthPage,
    isEsoftUser,
  };
};
